import esri = __esri;

import { aliasOf, property, subclass } from "esri/core/accessorSupport/decorators";
import EsriMap from "esri/Map";
import MapView from "esri/views/MapView";
import { tsx } from "esri/widgets/support/widget";
import Widget from "esri/widgets/Widget";
import * as setupView from "../widgets/App/setupView";
import AppViewModel, { AppParams } from "./App/AppViewModel";
import { Header } from "./Header";
import { illinoisExtent } from "./Toolbar/fullExtentTool";

interface AppViewParams extends AppParams, esri.WidgetProperties {}

const CSS = {
  base: "main",
  webmap: "webmap"
};

@subclass("app.widgets.webmapview")
export default class App extends Widget {
  @property() viewModel = new AppViewModel();

  @aliasOf("viewModel.appName") appName: string;
  @aliasOf("viewModel.appNotice") appNotice: string;
  @aliasOf("viewModel.appNoticeStart") appNoticeStart: string;
  @aliasOf("viewModel.appNoticeEnd") appNoticeEnd: string;

  @aliasOf("viewModel.map") map: EsriMap;

  @aliasOf("viewModel.view") view: __esri.MapView;

  constructor(params: Partial<AppViewParams>) {
    super(params);
  }

  render() {
    return (
      <div class={CSS.base}>
        {Header({ appName: this.appName, appNotice: this.appNotice, appNoticeStart: this.appNoticeStart, appNoticeEnd: this.appNoticeEnd })}
        <div class={CSS.webmap} bind={this} afterCreate={this.onAfterCreate}>
          <img id="loadingImg" class="loadingImg" src="assets/loading.gif" style="position:absolute; left:175px; top:200px; z-index:2000;" />
        </div>
      </div>
    );
  }

  private onAfterCreate(element: HTMLDivElement) {
    import("./../data/app").then(({ map }) => {
      try {
        this.map = map;

        const noticeStart = Date.parse(this.appNoticeStart);
        const noticeEnd = Date.parse(this.appNoticeEnd);

        const now = Date.now();

        const noticeSpan = document.getElementById("TopNavNotice") as HTMLElement;
        if (now >= noticeStart && now <= noticeEnd)
        {
          const largeText = document.getElementById("TopNavLargeText") as HTMLElement;
          largeText.innerHTML = "IROADS";
          noticeSpan.style.display = "block";
        }
        else
        {
          noticeSpan.style.display = "none";
        }
      
        this.view = new MapView({
          map: this.map,
          container: element,
          extent: illinoisExtent,
          
          highlightOptions: {
            color: setupView.highlightColor,
            haloOpacity: 0.9,
            fillOpacity: 0.7
          },
          
          constraints: {
            snapToZoom: false,
            minZoom: 5,
            rotationEnabled: false
          },
          spatialReference: {
            wkid: 102100
          }
        });

        this.view.popup.on("trigger-action", (event) => {
          if (event.action.id === "copy-asset-id") {
            // Access the selected graphic feature safely
            const selectedFeature = this.view.popup.selectedFeature;
            
            // Grab your specific attribute field string (e.g., 'AssetID')
            const assetId = selectedFeature.attributes["FilePath"];

            if (assetId) {
              // Execute the native web clipboard logic
              navigator.clipboard.writeText(String(assetId))
              .then(() => {
                  // Optional: Provide quick visual feedback to the user
                  const originalText = event.action.title;
                  event.action.title = "✓ Copied!";
                  setTimeout(() => { event.action.title = originalText; }, 2000);
                })
                .catch(err => {
                  console.error("Could not copy text: ", err);
                });
            }
          }
        });
        // 2. Clear, Type-Safe Native Click Interceptor
        // Since popups render inside this container element, this catches your span click perfectly
        element.addEventListener("click", (event: MouseEvent) => {
          const target = event.target as HTMLElement;
          
          if (target && target.classList.contains("open-plan-link")) {
            const networkPath = target.getAttribute("data-path");
            if (networkPath) {
              // Standardize backslashes to forward slashes for the browser engine
              const cleanPath = networkPath.replace(/\\/g, "/");
              const absoluteNetworkUrl = "file://///" + cleanPath;
              
              console.log("Opening Path via Interceptor:", absoluteNetworkUrl);
              window.open(absoluteNetworkUrl, "_blank");
            }
          }

          if (target && target.classList.contains("open-network-plan-file")) {
            var networkPath = target.getAttribute("data-path");
            networkPath = "file://illinois.gov/dot/EPLAN/DESENV/";
            
            if (networkPath) {
              window.open(networkPath, "_blank");
            } else {
              console.error("No file path found for this feature.");
            }
          }

          if (target && target.parentElement?.matches(".esri-icon-copy")) {
    
            // 2. Extract the attribute string stored on the button element
            // (e.g., <button class="copy-btn" data-asset-id="12345">Copy</button>)
            const textToCopy = target.getAttribute("data-asset-id");

            if (textToCopy) {
              // 3. Use the native Web Clipboard API to copy the text
              navigator.clipboard.writeText(textToCopy)
                .then(() => {
                  // Optional: Provide quick visual feedback to the user
                  const originalText = target.innerText;
                  target.innerText = "✓ Copied!";
                  setTimeout(() => { target.innerText = originalText; }, 2000);
                })
                .catch(err => {
                  console.error("Could not copy text: ", err);
                });
            }
          }
        });
        
        } catch (error) {
        console.error("Error: in onAfterCreate (webapp div) " + error.message);
      }
    });
  }

}
